<template>
  <div class="ivu-modal-render-modal">
    <div :class="body_classes">
      <spin v-if="is_loading" size="large" fix />
      <div v-if="$slots['title']" class="ivu-modal-confirm-head ivu-modal-confirm-head--slot">
        <div class="ivu-modal-confirm-head-title"><slot name="title"></slot></div>
      </div>
      <div v-if="$slots['description']" class="ivu-modal-confirm-description">
        <slot name="description"></slot>
        <div>
          <slot name="format"></slot>
        </div>
      </div>
      <slot :is_button_loading="is_button_loading"></slot>
    </div>

    <div v-if="!hide_footer" class="ivu-modal-render-footer">
      <slot name="footer-cancel" :close="close">
        <i-button size="large" @click="close()">
          {{ $t('shared.component.button.cancel') }}
        </i-button>
      </slot>
      <slot name="footer-ok" :is_button_loading="is_button_loading"></slot>
    </div>
  </div>
</template>

<script>
  import { findComponentUpward } from 'view-design/src/utils/assist';

  export default {
    props: {
      show_cancel: {
        type: Boolean,
        default: true
      },

      is_loading: {
        type: Boolean,
        default: false
      },

      hide_footer: {
        type: Boolean,
        default: false
      },

      body_class: {
        type: [Array, String],
        default: () => []
      }
    },

    data() {
      return {
        is_button_loading: false
      };
    },

    computed: {
      body_classes: function() {
        const base_class = ['ivu-modal-render-body'];
        const props_classes = this.body_class;
        let new_classes = [];

        if (typeof props_classes === 'string') {
          new_classes = props_classes.split(' ');
        } else if (Array.isArray(props_classes)) {
          new_classes = props_classes;
        }

        return [...base_class, ...new_classes];
      }
    },

    mounted() {
      const modal = findComponentUpward(this, 'Modal').$parent;
      this.$watch(
        () => modal.buttonLoading,
        current_value => (this.is_button_loading = current_value),
        { immediate: true }
      );
    },

    methods: {
      close: function() {
        findComponentUpward(this, 'Modal').cancel();
      }
    }
  };
</script>
